import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IConfig } from 'ngx-mask';

import { QrCodeModalComponent } from './modals/qrcode/qrcode-modal.component';
import { TransversalEventsService } from './services/transversal-events.service';

import { IdtEcommerceApiModule } from '@api/idt-ecommerce-api.module';
import { UiService } from '@core/services/ui.service';
import { LegacyModule } from '@legacy.module';
import { ABTestingModule } from '@shared/ab-testing/AB-testing.module';
import { AnalyticsModule } from '@shared/analytics/analytics.module';
import { ErrorsModule } from '@shared/errors/errors.module';
import { GoogleServicesModule } from '@shared/google-services/google-services.module';
import { ShopcartModule } from '@shared/shopcart/shopcart.module';
import { DialogModule } from '@ui/dialog/dialog.module';
import { QrcodeComponent } from '@ui/qrcode/qrcode.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

/**
 * @deprecated Este módulo se irá fragmentando en pequeñas funcionalidades y se desaconseja su uso, comprueba si la funcionalidad que necesites la puedes importar individualmente
 */
@NgModule({
    imports: [
        ABTestingModule,
        AnalyticsModule,
        CommonModule,
        DialogModule,
        ErrorsModule,
        LegacyModule.forRoot(),
        FormsModule,
        FormsModule,
        GoogleServicesModule,
        IdtEcommerceApiModule,
        QrcodeComponent,
        TranslateModule.forChild(),
        ReactiveFormsModule,
        ShopcartModule,
    ],
    providers: [
        TransversalEventsService,
        UiService,
    ],
    exports: [
        FormsModule,
        QrCodeModalComponent,
        ReactiveFormsModule,
    ],
    declarations: [
        QrCodeModalComponent,
    ],
})
export class DuttiCommonModule {
    constructor(private readonly transversalEventsService: TransversalEventsService) {
        // TODO ECOMDUTI-21020 [TechDebt]: Borrar esyte servicio
        this.transversalEventsService.init();
    }
}
